import * as Yup from "yup";

export const directorApprovalsValidationSchema = Yup.object({
  fileUploads: Yup.object({
    signedDirectorApprovalDocs: Yup.string().required(
      "Director approval docs is required"
    ),
  }),
});

export const shareholderApprovalsValidationSchema = Yup.object({
  fileUploads: Yup.object({
    signedShareholderApprovalDocs: Yup.string().required(
      "Shareholder approval docs is required"
    ),
  }),
});
